import { DesignerBase } from './designer-base.model';
import { DesignerSchemaField, DesignerSchemaFieldI } from './designer-schema-field.model';

export class DesignerSchema extends DesignerBase {
  id = null;
  name = null;
  valid = true;
  fields: Array<DesignerSchemaField | DesignerSchemaFieldI> = [];

  setData(data) {
    if (!data || !data.fields) return;

    this.fields = [];

    data.fields.forEach((field) => {
      this.addField(field);
    });
  }

  getData() {
    const fields = this.fields.map((field) =>
      (field as DesignerSchemaField).getData ? (field as DesignerSchemaField).getData() : field,
    );

    return {
      valid: this.valid,
      fields,
    };
  }

  getSchema() {
    const fields = [];

    this.fields.forEach((field) => {
      if (field.alias) fields.push({ name: field.alias });
      else if (field.projected_name) fields.push({ name: field.projected_name });
      else if (field.name) fields.push({ name: field.name });
    });

    return {
      valid: this.valid,
      fields,
    };
  }

  addField(data: Partial<DesignerSchemaFieldI>) {
    const field = new DesignerSchemaField(data);

    this.fields = [...this.fields, field];
  }

  removeFieldByName(name: string) {
    this.fields = this.fields.filter((item) => item.name !== name);
  }

  removeAllFields() {
    this.fields = [];
  }
}
